import EditAreaOptionDialog from './EditAreaOptionDialog'

export default EditAreaOptionDialog
